// removed by extract-text-webpack-plugin
module.exports = {"screen":"_1QeIuRPrHM1Q2QgJ4zev7n_0","inner":"IfZKF666fKNn4WDjKcWrl_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dd946eea","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Alert/AlertInner.vue
// module id = VcjD
// module chunks = 4